module.exports = __webpack_public_path__ + "static/media/Tech_firstPage_en.a69de7a9.png";